import { AppJsonDecoder } from 'src/app/utils/app-json-decoder';
import isMongoId from 'validator/es/lib/isMongoId';

export interface LicenseAutoAssignment {
  id?: string;
  headquarters?: string[];
  user_types?: string[];
  departments?: string[];
  years?: number[];
  sections?: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

export class License {
  id?: string;
  headquarters?: string[];
  title?: string;
  dashboard_link?: string;
  favicon?: string;
  link?: string;
  private_key?: string;
  key?: string;
  available?: number;
  start?: Date;
  end?: Date;
  enabled?: boolean;
  instructions?: string;
  activeAssignmentsCount?: number;
  createdAt?: Date;
  updatedAt?: Date;
  auto_assignments?: LicenseAutoAssignment[];

  constructor(json?: any) {
    if (!json) return;
    if (isMongoId(json.toString().trim())) {
      this.id = json.toString().trim();
      return;
    }
    this.id = json['_id'] || json['id'];
    this.headquarters = json['headquarters'] || [];
    this.title = json['title'];
    this.dashboard_link = json['dashboard_link'];
    this.favicon = json['favicon'];
    this.link = json['link'];
    this.key = json['key'];
    this.private_key = json['private_key'];
    this.available = json['available'];
    this.instructions = json['instructions'];
    this.end = AppJsonDecoder.optDate(json['end']);
    this.start = AppJsonDecoder.optDate(json['start']);
    this.enabled = AppJsonDecoder.optBool(json['enabled']);
    this.createdAt = AppJsonDecoder.optDate(json['createdAt']);
    this.updatedAt = AppJsonDecoder.optDate(json['updatedAt']);
    this.activeAssignmentsCount = json['activeAssignmentsCount'];
    this.auto_assignments = (json['auto_assignments'] || []).map(
      (assignment: any) =>
        ({
          id: assignment['_id'] || assignment['id'],
          headquarters: assignment['headquarters'] || [],
          user_types: assignment['user_types'] || [],
          departments: assignment['departments'] || [],
          years: assignment['years'] || [],
          sections: assignment['sections'] || [],
          createdAt: AppJsonDecoder.optDate(assignment['createdAt']),
          updatedAt: AppJsonDecoder.optDate(assignment['updatedAt']),
        } as LicenseAutoAssignment)
    );
  }
}
